// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrContainer_KywU7{

    width: 100%;
    margin: 20px auto;
  }

  .DocSection_Vd1ta{
    p,.labelName_vm21w{
      color: #000 !important;
      margin: 0;
      font-weight: 500;
      font-size: 15px;
    }
  }
.expirationDateContainer_H3m4N{
  display: flex;
  flex-direction: column;
  gap: 5px;
}
  .expirationDateContent_nvGMS{
    margin-bottom: 0px;
    font-size: 15px;
    font-weight: 500;
    color: var(--black-color);
    display: inline-block;
    height: 30px;
    display: flex;
    align-items: center;

  }
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/InfoBill/DocSection/DocSection.module.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,gBAAgB;MAChB,eAAe;IACjB;EACF;AACF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;EACE;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,mBAAmB;;EAErB","sourcesContent":[".qrContainer{\n\n    width: 100%;\n    margin: 20px auto;\n  }\n\n  .DocSection{\n    p,.labelName{\n      color: #000 !important;\n      margin: 0;\n      font-weight: 500;\n      font-size: 15px;\n    }\n  }\n.expirationDateContainer{\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n  .expirationDateContent{\n    margin-bottom: 0px;\n    font-size: 15px;\n    font-weight: 500;\n    color: var(--black-color);\n    display: inline-block;\n    height: 30px;\n    display: flex;\n    align-items: center;\n\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"qrContainer": `qrContainer_KywU7`,
	"DocSection": `DocSection_Vd1ta`,
	"labelName": `labelName_vm21w`,
	"expirationDateContainer": `expirationDateContainer_H3m4N`,
	"expirationDateContent": `expirationDateContent_nvGMS`
};
export default ___CSS_LOADER_EXPORT___;
